var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"col":"12"}},[_c('b-overlay',{staticClass:"d-inline-block w-100",attrs:{"show":_vm.isBusy,"rounded":"","opacity":"0.6","spinner-small":"","spinner-variant":"primary"}},[_c('b-card',{staticClass:"mt-3"},[_c('center',[_vm._v("Updating Data...")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }